// state
import axios from "axios";
import commonservice from "../../../shared/common.service";

const defaultState = () => ({
  id: null,
  name: null,
  description: null,
  pageList: [],
  selectedPageList: []
});

const state = defaultState();
// getters
const getters = {};

// actions
const actions = {
  loadRole({}, { pagination, search }) {
    return new Promise((resolve, reject) => {
      var param = {
        descending:
          pagination.sortDesc.length > 0 ? pagination.sortDesc[0] : false,
        page: pagination.page,
        rowsPerPage: pagination.itemsPerPage,
        sortBy: pagination.sortBy.length > 0 ? pagination.sortBy[0] : "name",
        search: search
      };
      axios
        .get("/roles?" + commonservice.convertToQueryString(param))
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setRole({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/roles/" + id)
        .then(response => {
          commit("SET_ROLE", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  initRole({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/list/page")
        .then(response => {
          commit("SET_PAGE_LIST", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveRole({ commit, state }) {
    return new Promise((resolve, reject) => {
      const role = {
        id: state.id,
        name: state.name,
        description: state.description,
        pages: state.selectedPageList.map(item => {
          return { pageId: item };
        })
      };
      if (state.id) {
        axios
          .patch("/roles", role)
          .then(response => {
            commit("RESET");
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        axios
          .post("/roles", role)
          .then(response => {
            commit("RESET");
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      }
    });
  },
  deleteRole({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/roles/" + id)
        .then(response => {
          commit("RESET");
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  RESET(state) {
    const pageList = state.pageList;
    Object.assign(state, defaultState());
    state.pageList = pageList;
  },
  SET_ROLE_DATA(state, data) {
    if (Object.prototype.toString.call(state[data.key]) === "[object Array]") {
      if (data.index != undefined && data.property != undefined)
        state[data.key][data.index][data.property] = data.value;
      else state[data.key] = data.value;
    } else if (
      Object.prototype.toString.call(state[data.key]) === "[object Object]"
    ) {
      state[data.key][data.property] = data.value;
    } else state[data.key] = data.value;
  },
  SET_ROLE(state, data) {
    state.id = data.id;
    state.name = data.name;
    state.description = data.description;
    state.pageList = data.pageList;
    state.selectedPageList = [];
    mutations.getSelectedPage(state, data.pageList);
  },
  SET_PAGE_LIST(state, data) {
    state.pageList = data;
  },
  getSelectedPage(state, list) {
    list.forEach(item => {
      if (item.subPages.length > 0)
        mutations.getSelectedPage(state, item.subPages);
      else if (item.isSelected == 1) {
        state.selectedPageList.push(item.id);
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
